import p from "react";
import { Symbols as l } from "../shape/Symbols.js";
import { Shape as f } from "./ActiveShapeUtils.js";
var c = ["option", "isActive"];
function i() {
  return i = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];
      for (var t in r)
        Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
    }
    return e;
  }, i.apply(this, arguments);
}
function s(e, n) {
  if (e == null) return {};
  var r = m(e, n), t, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      t = a[o], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (r[t] = e[t]);
  }
  return r;
}
function m(e, n) {
  if (e == null) return {};
  var r = {};
  for (var t in e)
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      if (n.indexOf(t) >= 0) continue;
      r[t] = e[t];
    }
  return r;
}
function y(e) {
  var n = e.option, r = e.isActive, t = s(e, c);
  return typeof n == "string" ? /* @__PURE__ */ p.createElement(f, i({
    option: /* @__PURE__ */ p.createElement(l, i({
      type: n
    }, t)),
    isActive: r,
    shapeType: "symbols"
  }, t)) : /* @__PURE__ */ p.createElement(f, i({
    option: n,
    isActive: r,
    shapeType: "symbols"
  }, t));
}
export {
  y as ScatterSymbol
};
